import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  TextField,
  Typography,
  CircularProgress,
  Divider
} from '@material-ui/core';
import React, { useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { createAPICode } from 'src/store/actions/KeyManagerActions';

function CreateAPIKey({ open, handleClose }) {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleCreateAPI = async values => {
    setLoading(true);
    const response = await dispatch(createAPICode(values));
    if (response === 1) {
      setLoading(false);
      handleClose();
    } else {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Typography color="textPrimary" variant="h2">
          Create Key
        </Typography>
      </DialogTitle>
      <Divider />
      <Formik
        initialValues={{
          name: '',
          userid: '',
          usersecret: ''
        }}
        validationSchema={Yup.object().shape({
          name: Yup.string()
            .trim()
            .max(255)
            .required('Name is required'),
          userid: Yup.string()
            .trim()
            .max(255)
            .required('User ID is required'),
          usersecret: Yup.string()
            .trim()
            .max(255)
            .required('User Secret key is required')
        })}
        onSubmit={values => {
          handleCreateAPI(values);
          // navigate('/app/dashboard', { replace: true });
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          values
        }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <TextField
                error={Boolean(touched.name && errors.name)}
                fullWidth
                helperText={touched.name && errors.name}
                label="Name"
                margin="normal"
                name="name"
                onBlur={handleBlur}
                onChange={handleChange}
                type="text"
                value={values.name}
                variant="outlined"
                size="small"
              />
              <TextField
                error={Boolean(touched.userid && errors.userid)}
                fullWidth
                helperText={touched.userid && errors.userid}
                label="User ID"
                margin="normal"
                name="userid"
                onBlur={handleBlur}
                onChange={handleChange}
                type="text"
                value={values.userid}
                variant="outlined"
                size="small"
              />
              <TextField
                error={Boolean(touched.usersecret && errors.usersecret)}
                fullWidth
                helperText={touched.usersecret && errors.usersecret}
                label="User Secret"
                margin="normal"
                name="usersecret"
                onBlur={handleBlur}
                onChange={handleChange}
                type="text"
                value={values.usersecret}
                variant="outlined"
                size="small"
              />
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" onClick={handleClose}>
                Close
              </Button>
              <Button
                disabled={loading}
                variant="contained"
                color="primary"
                type="submit"
              >
                {loading && <CircularProgress size="1.5rem" />}
                Create
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
}

export default CreateAPIKey;
